import { useCallback } from "react"
import { authActions } from "../store/auth-slice"
import { useDispatch } from "react-redux"
import { accountsActions } from "../store/accounts-slice"
import { campaignsActions } from "../store/campaigns-slice"
import { donorsActions } from "../store/donors-slice"
import { donorRelationsActions } from "../store/donorRelations-slice"
import { pledgesActions } from "../store/pledges-slice"
import { filtersActions } from "../store/filters-slice"
import { organizationsActions } from "../store/organizations-slice"
import { paymentsActions } from "../store/payments-slice"
import { paymentTypesActions } from "../store/paymentTypes-slice"
import { tendersActions } from "../store/tenders-slice"
import { solicitorsActions } from "../store/solicitors-slice"
import { shulsActions } from "../store/shuls-slice"
import { statementsActions } from "../store/statements-slice"
import { settingsActions } from "../store/settings-slice"
import { studentsActions } from "../store/students-slice"
import { hubActions } from "../store/hub-slice"
import { locationsActions } from "../store/locations-slice"
import { remindersActions } from "../store/reminders-slice"
import { uiActions } from "../store/ui-slice"
import { parentsActions } from "../store/parents-slice"
import { schoolActions } from "../store/school-slice"


const useResetState = () => {
    const dispatch = useDispatch()

    // Clears loaded app data without ending the auth session (e.g. support exit company).
    const clearBusinessState = useCallback(() => {
        dispatch(accountsActions.resetState())
        dispatch(campaignsActions.resetState())
        dispatch(organizationsActions.resetState())
        dispatch(settingsActions.resetState())

        dispatch(donorsActions.resetState())
        dispatch(donorRelationsActions.resetState())
        dispatch(pledgesActions.resetState())
        dispatch(paymentsActions.resetState())
        dispatch(paymentTypesActions.resetState())

        dispatch(filtersActions.resetState())

        dispatch(tendersActions.resetState())
        dispatch(solicitorsActions.resetState())
        dispatch(shulsActions.resetState())
        dispatch(statementsActions.resetState())
        dispatch(studentsActions.resetState())
        dispatch(hubActions.resetState())
        dispatch(locationsActions.resetState())
        dispatch(remindersActions.resetState())
        dispatch(parentsActions.resetState())
        dispatch(schoolActions.resetState())

        dispatch(uiActions.resetNotification())
        dispatch(uiActions.resetErrorMessage())
    }, [dispatch])

    const resetState = useCallback(() => {
        dispatch(authActions.logout())
        clearBusinessState()
    }, [dispatch, clearBusinessState])

    return {
        resetState,
        clearBusinessState
    }
}
export default useResetState
